module.exports = __webpack_public_path__ + "media/images/lb/499-4be1be4c8974b8d780d15f781df29b7b.svg";